import { combineReducers } from 'redux';
import create from './alertMPG/create';
import list from './alertMPG/list';
import modify from './alertMPG/modify';

export default combineReducers({
    create,
    list,
    modify,
});



// WEBPACK FOOTER //
// ./src/reducers/app/alertMPG.js